import styled from 'styled-components';
import { colors } from 'Constants/Colors';

const ContainerCourse = styled.div`
  width: 100%;
  background: ${colors.BLUE_GRAY};
  height: auto;
  min-height: 100vh;
  box-sizing: border-box;
`;

const ContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${colors.WHITE};
  min-height: 20vh;
  padding: 1.5rem;
  justify-content: space-between;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  align-items: center;
`;

const HeaderThumbnail = styled.div`
  background: ${colors.GRAY};
  width: 125px;
  height: 100px;
  margin-right: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
`;

const thumbnail = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '1rem',
};

const HeaderInfo = styled.div`
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.25rem;
  min-height: 100%;
  box-sizing: border-box;
`;

const HeaderTitle = styled.div`
  font-size: 1.6rem;
  font-family: metropolis;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  align-items: center;
`;

const HeaderSubTitle = styled.div`
  font-size: 0.9rem;
  display: flex;
  flex-direction: row;
  font-family: metropolis;
  gap: 2rem;
  justify-content: flex-start;
  align-items: center;
`;

const HeaderEditButton = styled.div`
  position: absolute;
  background: ${colors.GREEN_LEAF};
  display: flex;
  align-items: center;
  border-radius: 50%;
  padding: 0.2rem;
  top: 6.5rem;
  right: 2rem;
  color: ${colors.WHITE};
  cursor: pointer;
`;

const checkIcon = {
  color: colors.GREEN_SHINING_ULTRA,
  fontSize: '1.5rem',
};

const LastUpdatedContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

const LastUpdated = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
`;

const lastUpdatedText = {
  color: colors.GRAY_DARK,
};

const lastUpdatedLabel = {
  fontWeight: 'bold',
};

export default {
  ContainerCourse,
  ContainerHeader,
  HeaderContent,
  HeaderThumbnail,
  HeaderInfo,
  HeaderTitle,
  HeaderSubTitle,
  HeaderEditButton,
  thumbnail,
  checkIcon,
  LastUpdated,
  LastUpdatedContainer,
  lastUpdatedLabel,
  lastUpdatedText,
};
